// extracted by mini-css-extract-plugin
export default {"table-container":"HomeSlider_table-container__wqoC2"};